import React from 'react';

import AssistantMessage from './assistant_message';
import ConversationStarters from './conversation_starters';
import LoadingSpinner from 'components/ui/loading_spinner';
import UserMessage from './user_message';

import type { Message } from '../types';

interface Props {
  messages: Message[];
  restoring: boolean;
  onSelectStarter: (prompt: string) => void;
}

export function Transcript({ messages, restoring, onSelectStarter }: Props) {
  // A card is only history once the user has typed past it. An assistant message after it is the
  // reply it is still waiting on - or the error from a failed attempt, which it can be retried from.
  const lastUserIndex = messages.reduce((last, { role }, index) => (role === 'user' ? index : last), -1);

  if (messages.length === 0) {
    return restoring ? <LoadingSpinner /> : <ConversationStarters onSelect={onSelectStarter} />;
  }

  return (
    <>
      {messages.map((message, index) => (
        message.role === 'user'
          ? <UserMessage key={index} message={message} />
          : <AssistantMessage key={index} message={message} superseded={index < lastUserIndex} />
      ))}
    </>
  );
}
